import { Stage, Sprite, SpriteSheet, Ticker } from '@createjs/easeljs';

import meeting from '../spritesheets/meeting_anim.png';

class MeetingAnimation {
    constructor() {
        this.meeting = null;

        this._createMeetingSprite();
    }

    _createMeetingSprite() {
        const spriteSheet = new SpriteSheet({
            images: [meeting],
            frames: [
                [1, 1, 119, 109, 0, -18.45, -0.700000000000002],
                [122, 1, 119, 112, 0, -18.45, 2.29999999999999],
                [243, 1, 119, 133, 0, -18.45, 23.2999999999999],
                [364, 1, 119, 155, 0, -18.45, 45.3],
                [485, 1, 131, 171, 0, -18.45, 61.3],
                [618, 1, 142, 181, 0, -18.45, 71.3],
                [762, 1, 145, 184, 0, -18.45, 74.3],
                [1, 187, 140, 179, 0, -18.45, 69.3],
                [143, 187, 135, 174, 0, -18.45, 64.3],
                [280, 187, 130, 170, 0, -18.45, 60.3],
                [412, 187, 130, 170, 0, -18.45, 60.3],
                [544, 187, 130, 170, 0, -18.45, 60.3],
                [676, 187, 130, 170, 0, -18.45, 60.3],
                [676, 187, 130, 170, 0, -18.45, 60.3],
                [676, 187, 130, 170, 0, -18.45, 60.3],
                [676, 187, 130, 170, 0, -18.45, 60.3],
                [808, 187, 119, 154, 0, -18.45, 44.3],
                [1, 368, 119, 137, 0, -18.45, 27.2999999999999],
                [122, 368, 119, 121, 0, -18.45, 11.2999999999999],
                [243, 368, 119, 109, 0, -18.45, -0.700000000000002],
                [1, 1, 119, 109, 0, -18.45, -0.700000000000002],
                [364, 368, 119, 109, 0, -18.45, -0.700000000000002],
                [485, 368, 119, 134, 0, -18.45, 23.2999999999999],
                [606, 368, 119, 157, 0, -18.45, 45.3],
                [727, 368, 125, 173, 0, -12.45, 61.3],
                [854, 368, 135, 183, 0, -2.45, 71.3],
                [1, 553, 138, 185, 0, 0.55, 74.3],
                [141, 553, 133, 179, 0, -4.45, 69.3],
                [276, 553, 129, 175, 0, -8.45, 64.3],
                [407, 553, 124, 172, 0, -13.45, 60.3],
                [533, 553, 124, 172, 0, -13.45, 60.3],
                [407, 553, 124, 172, 0, -13.45, 60.3],
                [659, 553, 124, 171, 0, -13.45, 60.3],
                [785, 553, 124, 170, 0, -13.45, 60.3],
                [785, 553, 124, 170, 0, -13.45, 60.3],
                [785, 553, 124, 170, 0, -13.45, 60.3],
                [1, 740, 119, 154, 0, -18.45, 44.3],
                [122, 740, 119, 137, 0, -18.45, 27.2999999999999],
                [243, 740, 119, 121, 0, -18.45, 11.2999999999999],
                [364, 368, 119, 109, 0, -18.45, -0.700000000000002],
            ],
            // framerate: 15,
            animations: {
                go: [0, 39, 'go', 3],
            },
        });

        this.meeting = new Sprite(spriteSheet, 'go');
        this.meeting.x = 275;
        this.meeting.y = 150;
        this.meeting.scaleY = this.meeting.scaleX = 1.5;
    }

    initialise(id) {
        this.stage = new Stage(id);
        this.stage.addChild(this.meeting);
        this.stage.update();
        Ticker.on('tick', this.stage);
    }

    destroy() {
        Ticker.off('tick', this.stage);
        this.stage.removeChild(this.meeting);
        this.stage.clear();
        this.stage.update();
    }
}

export { MeetingAnimation };
